import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {faCircle,faCircleHalfStroke,faPlay,faChevronUp,faBars,faShapes,faMagnifyingGlass,faStop,faDiamond,faStar,faCertificate,faMessage,faPlus,faEgg,faBookmark,faHeart,faInfinity,faLock} from '@fortawesome/free-solid-svg-icons'
import axios from 'axios'

export default function Shapenav(props) {
  var apnd=(nm)=>{
    setTimeout(() => {
      document.getElementById('entid').classList='ent';
      document.getElementById('entid').classList.add(nm);
    }, 10);
  }
  const enlight=(idz)=>{
    for(let i=0;i<16;i++){
      document.getElementsByClassName('shapeicons')[i].classList='shapeicons'
    }
    document.getElementById(idz).classList.add("shapeiconsSelected")
  }
  const getshape=async(idz)=>{
    props.shp2code(await axios.post('https://sclib.onrender.com/shapes',{[idz]:{$exists:true}}))
  }
  const idz=[
    "faStop",
    "faCircle",
    "faCircleHalfStroke",
    "faPlay",
    "faChevronUp",
    "faDiamond",
    "faStar",
    "faCertificate",
    "faMessage",
    "faPlus",
    "faEgg",
    "faBookmark",
    "faHeart",
    "faInfinity",
    "faLock",
    "faMagnifyingGlass",
    "faBars"
  ]
  const cls=[
  'square',
  'circle',
  'semi_circle',
  'triangle_right',
  'arrow',
  'diamond',
  'star_five',
  'star_twelve',
  'bubble4',
  'cross',
  'egg',
  'flag',
  'heart',
  'infinity',
  'lock',
  'mag'
]
  return (
    <div className='shapenav'>
        <div className='flex shapehead'><FontAwesomeIcon icon={faShapes} /></div>
        <div className='shapeicons shapeiconsSelected' id={idz[0]} onClick={async()=>{apnd(cls[0]);enlight(idz[0]);getshape(cls[0]);props.shapekey(cls[0])}}><FontAwesomeIcon icon={faStop} /></div>
        <div className='shapeicons' id={idz[1]} onClick={async()=>{apnd(cls[1]);enlight(idz[1]);getshape(cls[1]);props.shapekey(cls[1])}}><FontAwesomeIcon icon={faCircle}/></div>
        <div className='shapeicons' id={idz[2]} onClick={async()=>{apnd(cls[2]);enlight(idz[2]);getshape(cls[2]);props.shapekey(cls[2])}}><FontAwesomeIcon icon={faCircleHalfStroke} /></div>
        <div className='shapeicons' id={idz[3]} onClick={async()=>{apnd(cls[3]);enlight(idz[3]);getshape(cls[3]);props.shapekey(cls[3])}}><FontAwesomeIcon icon={faPlay} /></div>
        <div className='shapeicons' id={idz[4]} onClick={async()=>{apnd(cls[4]);enlight(idz[4]);getshape(cls[4]);props.shapekey(cls[4])}}><FontAwesomeIcon icon={faChevronUp} /></div>
        <div className='shapeicons' id={idz[5]} onClick={async()=>{apnd(cls[5]);enlight(idz[5]);getshape(cls[5]);props.shapekey(cls[5])}}><FontAwesomeIcon icon={faDiamond} /></div>
        <div className='shapeicons' id={idz[6]} onClick={async()=>{apnd(cls[6]);enlight(idz[6]);getshape(cls[6]);props.shapekey(cls[6])}}><FontAwesomeIcon icon={faStar} /></div>
        <div className='shapeicons' id={idz[7]} onClick={async()=>{apnd(cls[7]);enlight(idz[7]);getshape(cls[7]);props.shapekey(cls[7])}}><FontAwesomeIcon icon={faCertificate} /></div>
        <div className='shapeicons' id={idz[8]} onClick={async()=>{apnd(cls[8]);enlight(idz[8]);getshape(cls[8]);props.shapekey(cls[8])}}><FontAwesomeIcon icon={faMessage} /></div>
        <div className='shapeicons' id={idz[9]} onClick={async()=>{apnd(cls[9]);enlight(idz[9]);getshape(cls[9]);props.shapekey(cls[9])}}><FontAwesomeIcon icon={faPlus} /></div>
        <div className='shapeicons' id={idz[10]} onClick={async()=>{apnd(cls[10]);enlight(idz[10]);getshape(cls[10]);props.shapekey(cls[10])}}><FontAwesomeIcon icon={faEgg} /></div>
        <div className='shapeicons' id={idz[11]} onClick={async()=>{apnd(cls[11]);enlight(idz[11]);getshape(cls[11]);props.shapekey(cls[11])}}><FontAwesomeIcon icon={faBookmark} /></div>
        <div className='shapeicons' id={idz[12]} onClick={async()=>{apnd(cls[12]);enlight(idz[12]);getshape(cls[12]);props.shapekey(cls[12])}}><FontAwesomeIcon icon={faHeart} /></div>
        <div className='shapeicons' id={idz[13]} onClick={async()=>{apnd(cls[13]);enlight(idz[13]);getshape(cls[13]);props.shapekey(cls[13])}}><FontAwesomeIcon icon={faInfinity} /></div>
        <div className='shapeicons' id={idz[14]} onClick={async()=>{apnd(cls[14]);enlight(idz[14]);getshape(cls[14]);props.shapekey(cls[14])}}><FontAwesomeIcon icon={faLock} /></div>
        <div className='shapeicons' id={idz[15]} onClick={async()=>{apnd(cls[15]);enlight(idz[15]);getshape(cls[15]);props.shapekey(cls[15])}}><FontAwesomeIcon icon={faMagnifyingGlass} /></div>
    </div>
  )
}
